import React, { useCallback, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AddIcon from "@mui/icons-material/Add";
import { MdOutlineAssignmentTurnedIn } from "react-icons/md";
import { PiUserCheck } from "react-icons/pi";
import { MdOutlineEdit } from "react-icons/md";
import { RiDeleteBinLine } from "react-icons/ri";
import { LuCalendarDays } from "react-icons/lu";
import Button from "react-bootstrap/Button";
import ButtonCom from "../../../components/button/button";
import { ToastContainer } from "react-toastify";
import Modal from "react-bootstrap/Modal";
import { Form } from "react-bootstrap";
import AssignEmployee from "../../../components/AssignEmployee";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

import { useDispatch, useSelector } from "react-redux";
import { fetchBranchData, initBranchState } from "../../../redux/slices/branchSlice";
import { fetchDepartmentData, initDepartState } from "../../../redux/slices/departmentSlice.js";
import { useGlobalToast } from "../../../stopOldToastGlobally.js";
import {
  commonGetDataFourth,
  commonSaveData,
  initCommonState,
} from "../../../redux/slices/commonSlice";
import { getAttendModule, initMoreSettState } from "../../../redux/slices/moreSettings";

import {
  getHolidayMainPath,
  deleteHolidayMainPath,
  getStaffHolidayListPath,
  assignHolidayEmployeePath,
  insertHolidayMainPath,
} from "../../../services/config";
import Widgets from "../../../components/Widgets";
import WidgetsIcon from "../../../components/Widgets/icon";
import { HasPermission } from "../../../services/hasPermission";

const API_BASE_URL = "https://internaltestinghrms.sktexus.com";
const GET_MY_HOLIDAY_LIST_API = `${API_BASE_URL}/api/admin/getMyHolidayList`;

// ─── Inline styles ────────────────────────────────────────────────────────────
const styles = {
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(320px, 1fr))",
    gap: "20px",
    padding: "20px",
  },
  card: {
    background: "#19152C",
    border: "1px solid #2a2d3e",
    borderRadius: "16px",
    padding: "20px",
    display: "flex",
    flexDirection: "column",
    gap: "14px",
    transition: "transform 0.2s, box-shadow 0.2s",
    cursor: "default",
  },
  iconBox: {
    width: "48px",
    height: "48px",
    background: "#6c47ff",
    borderRadius: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#fff",
    fontSize: "22px",
    flexShrink: 0,
  },
  moduleName: {
    fontSize: "18px",
    fontWeight: "700",
    color: "#ffffff",
    margin: "0",
  },
  dateBadge: {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    border: "1px solid #2ecc71",
    borderRadius: "6px",
    padding: "4px 10px",
    fontSize: "12px",
    fontWeight: "600",
    color: "#2ecc71",
    width: "fit-content",
  },
  divider: {
    height: "1px",
    background: "rgb(42, 22, 85)",
    margin: "2px 0",
  },
  statsRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  statsLeft: {},
  statsLabel: {
    fontSize: "10px",
    fontWeight: "600",
    color: "#6b7280",
    textTransform: "uppercase",
    letterSpacing: "0.08em",
    marginBottom: "2px",
  },
  statsValue: {
    fontSize: "28px",
    fontWeight: "800",
    color: "#8b5cf6",
    lineHeight: 1,
  },
  statsUnit: {
    fontSize: "13px",
    fontWeight: "500",
    color: "#8b92a5",
    marginLeft: "4px",
  },
  assignedBox: {
    background: "#0f2a1a",
    border: "1px solid #1a5c35",
    borderRadius: "10px",
    padding: "8px 18px",
    textAlign: "center",
  },
  assignedLabel: {
    fontSize: "10px",
    fontWeight: "600",
    color: "#2ecc71",
    textTransform: "uppercase",
    letterSpacing: "0.06em",
    display: "flex",
    alignItems: "center",
    gap: "4px",
    justifyContent: "center",
    marginBottom: "2px",
  },
  assignedValue: {
    fontSize: "28px",
    fontWeight: "800",
    color: "#2ecc71",
    lineHeight: 1,
    textAlign: "center",
  },
  tagsRow: {
    display: "flex",
    gap: "8px",
    flexWrap: "wrap",
  },
  tagCF: {
    display: "inline-flex",
    alignItems: "center",
    gap: "5px",
    border: "1px solid #d97706",
    borderRadius: "6px",
    padding: "3px 10px",
    fontSize: "12px",
    fontWeight: "600",
    color: "#f59e0b",
    background: "transparent",
  },
  tagEnc: {
    display: "inline-flex",
    alignItems: "center",
    gap: "5px",
    border: "1px solid #0e9bac",
    borderRadius: "6px",
    padding: "3px 10px",
    fontSize: "12px",
    fontWeight: "600",
    color: "#06b6d4",
    background: "transparent",
  },
  breakdownHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "8px",
  },
  breakdownTitle: {
    fontSize: "11px",
    fontWeight: "700",
    color: "#6b7280",
    textTransform: "uppercase",
    letterSpacing: "0.08em",
    borderLeft: "3px solid #6c47ff",
    paddingLeft: "8px",
  },
  breakdownCount: {
    fontSize: "11px",
    fontWeight: "600",
    color: "#8b5cf6",
    background: "rgba(139,92,246,0.12)",
    padding: "2px 8px",
    borderRadius: "20px",
  },
  breakdownList: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
  },
  breakdownItem: {
    background: "#12152a",
    borderRadius: "8px",
    padding: "8px 12px",
  },
  breakdownItemRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  breakdownItemName: {
    fontSize: "13px",
    fontWeight: "600",
    color: "#e2e8f0",
  },
  breakdownItemDays: {
    fontSize: "13px",
    fontWeight: "700",
    color: "#8b5cf6",
    background: "rgba(139,92,246,0.12)",
    padding: "1px 8px",
    borderRadius: "6px",
  },
  breakdownItemTags: {
    display: "flex",
    gap: "6px",
    marginTop: "5px",
    flexWrap: "wrap",
  },
  miniTagCF: {
    fontSize: "10px",
    fontWeight: "600",
    color: "#f59e0b",
    border: "1px solid #d97706",
    borderRadius: "4px",
    padding: "1px 6px",
    display: "inline-flex",
    alignItems: "center",
    gap: "3px",
  },
  miniTagEnc: {
    fontSize: "10px",
    fontWeight: "600",
    color: "#06b6d4",
    border: "1px solid #0e9bac",
    borderRadius: "4px",
    padding: "1px 6px",
    display: "inline-flex",
    alignItems: "center",
    gap: "3px",
  },
  actionsRow: {
    display: "flex",
    gap: "8px",
    marginTop: "4px",
  },
  btnAssign: {
    flex: 1,
    padding: "10px 0",
    borderRadius: "10px",
    background: "#16a34a",
    border: "none",
    color: "#fff",
    fontSize: "12px",
    fontWeight: "800",
    letterSpacing: "0.06em",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "6px",
    transition: "background 0.2s, transform 0.15s",
  },
  btnEdit: {
    flex: 1,
    padding: "10px 0",
    borderRadius: "10px",
    background: "#6c47ff",
    border: "none",
    color: "#fff",
    fontSize: "12px",
    fontWeight: "800",
    letterSpacing: "0.06em",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "6px",
    transition: "background 0.2s, transform 0.15s",
  },
  btnDelete: {
    flex: 1,
    padding: "10px 0",
    borderRadius: "10px",
    background: "#dc2626",
    border: "none",
    color: "#fff",
    fontSize: "12px",
    fontWeight: "800",
    letterSpacing: "0.06em",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "6px",
    transition: "background 0.2s, transform 0.15s",
  },
};

// ─── Data normaliser ───────────────────────────────────────────────────────────
const normaliseModule = (raw) => ({
  moduleId: raw.moduleId ?? raw.module_id ?? raw.id ?? "",
  moduleName: raw.moduleName ?? raw.module_name ?? raw.name ?? raw.title ?? "Unnamed Module",
  dateRange: (() => {
    const start = raw.startDate ?? raw.start_date ?? raw.from_date ?? "";
    const end = raw.endDate ?? raw.end_date ?? raw.to_date ?? "";
    if (start && end) {
      const fmt = (d) => new Date(d).toLocaleDateString("en-IN", { month: "long", year: "numeric" });
      return `${fmt(start)} – ${fmt(end)}`;
    }
    return raw.dateRange ?? raw.date_range ?? "";
  })(),
  totalLeaves: raw.totalLeaves ?? raw.leaveTypeCount ?? raw.leave_type_count ?? raw.total_leaves ?? 0,
  assignedCount: raw.assignedCount ?? raw.assigned_count ?? raw.assigned ?? raw.staffCount ?? 0,
  cfDays: raw.cfDays ?? raw.cf_days ?? raw.carry_forward ?? raw.carryForward ?? "—",
  encashmentOn: (() => {
    const v = raw.encashmentOn ?? raw.encashment_on ?? raw.encashment ?? raw.is_encashment;
    if (v == null) return false;
    return v === true || v === 1 || v === "1" || String(v).toLowerCase() === "yes";
  })(),
  leaveTypes: (() => {
    const arr = raw.leaveTypes ?? raw.leave_types ?? raw.leaves ?? raw.leaveList ?? [];
    return arr.map((lt) => ({
      name: lt.name ?? lt.leave_name ?? lt.leaveName ?? lt.title ?? "Leave",
      days: lt.days ?? lt.no_of_days ?? lt.noOfDays ?? lt.count ?? 0,
      cf: lt.cf ?? lt.carryForward ?? lt.carry_forward ?? null,
      enc: lt.enc ?? lt.encashment ?? lt.is_encashment ?? null,
    }));
  })(),
  _raw: raw,
});

// ─── Function to fetch counts for a module ───
const fetchModuleCounts = async (moduleId) => {
  try {
    const token = localStorage.getItem("token") || sessionStorage.getItem("token") || "";
    const response = await fetch(
      `${GET_MY_HOLIDAY_LIST_API}?holidayId=${moduleId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const data = await response.json();

    if (data && data.code === 200 && data.status === true && Array.isArray(data.data)) {
      let leaveCount = 0;
      let rhCount = 0;

      data.data.forEach((holiday) => {
        if (holiday.leave_status === "1" || holiday.leave_status === 1) {
          leaveCount++;
        }
        if (holiday.rh_status === "1" || holiday.rh_status === 1 || holiday.rh_status === "2") {
          rhCount++;
        }
      });

      return { leaveCount, rhCount };
    }
    return { leaveCount: 0, rhCount: 0 };
  } catch (error) {
    console.error(`Error fetching counts for module ${moduleId}:`, error);
    return { leaveCount: 0, rhCount: 0 };
  }
};

// ─── Single Holiday Card (Child Component) ─────────────────────────────────────
const HolidayCard = ({ module, onAssign, onEdit, onDelete }) => {
  const [hovered, setHovered] = useState(false);
  const [leaveCount, setLeaveCount] = useState(0);
  const [rhCount, setRhCount] = useState(0);
  const [loading, setLoading] = useState(true);

  const { moduleId, moduleName, dateRange, totalLeaves, assignedCount, cfDays, encashmentOn, leaveTypes } = module;

  // Fetch counts when moduleId changes
  useEffect(() => {
    const getCounts = async () => {
      setLoading(true);
      const counts = await fetchModuleCounts(moduleId);
      setLeaveCount(counts.leaveCount);
      setRhCount(counts.rhCount);
      setLoading(false);
    };
    if (moduleId) {
      getCounts();
    }
  }, [moduleId]);

  return (
    <div
      style={{
        ...styles.card,
        ...(hovered ? { transform: "translateY(-3px)", boxShadow: "0 12px 32px rgba(0,0,0,0.4)" } : {}),
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
        <div style={styles.iconBox}>
          <LuCalendarDays />
        </div>
      </div>
      <div>
        <p style={styles.moduleName}>{moduleName}</p>
      </div>

      {dateRange && (
        <div style={styles.dateBadge}>
          <LuCalendarDays size={12} />
          {dateRange}
        </div>
      )}

      <div style={styles.divider} />

      <div style={styles.statsRow}>
        <div style={styles.statsLeft}>
          <div style={styles.statsLabel}>Total Holidays</div>
          <div>
            <span style={styles.statsValue}>{totalLeaves}</span>
            <span style={styles.statsUnit}>days</span>
          </div>
        </div>
        <div style={styles.assignedBox}>
          <div style={styles.assignedLabel}>
            <MdOutlineAssignmentTurnedIn size={12} />
            ASSIGNED
          </div>
          <div style={styles.assignedValue}>{assignedCount}</div>
        </div>
      </div>

      {/* ─── Leave and RH Counts ─── */}
      <div style={{ display: "flex", gap: "12px", justifyContent: "space-between" }}>
        <div
          style={{
            background: "rgba(46,204,113,0.1)",
            borderRadius: "10px",
            padding: "8px",
            textAlign: "center",
            flex: 1,
          }}
        >
          <div style={{ fontSize: "10px", color: "#2ecc71", fontWeight: "600", textTransform: "uppercase" }}>
            ✅ Leave Applicable
          </div>
          <div style={{ fontSize: "24px", fontWeight: "800", color: "#2ecc71" }}>
            {loading ? "..." : leaveCount}
          </div>
        </div>
        <div
          style={{
            background: "rgba(245,158,11,0.1)",
            borderRadius: "10px",
            padding: "8px",
            textAlign: "center",
            flex: 1,
          }}
        >
          <div style={{ fontSize: "10px", color: "#f59e0b", fontWeight: "600", textTransform: "uppercase" }}>
            🔒 Restricted Holiday
          </div>
          <div style={{ fontSize: "24px", fontWeight: "800", color: "#f59e0b" }}>
            {loading ? "..." : rhCount}
          </div>
        </div>
      </div>

      <div style={styles.tagsRow}>
        {cfDays && cfDays !== "—" && <span style={styles.tagCF}>↻ CF: {cfDays}</span>}
        {encashmentOn && <span style={styles.tagEnc}>💰 Encashment On</span>}
      </div>

      {leaveTypes.length > 0 && (
        <>
          <div style={styles.divider} />
          <div>
            <div style={styles.breakdownHeader}>
              <span style={styles.breakdownTitle}>Leave Breakdown</span>
              <span style={styles.breakdownCount}>{leaveTypes.length} types</span>
            </div>
            <div style={styles.breakdownList}>
              {leaveTypes.map((lt, idx) => (
                <div key={idx} style={styles.breakdownItem}>
                  <div style={styles.breakdownItemRow}>
                    <span style={styles.breakdownItemName}>{lt.name}</span>
                    <span style={styles.breakdownItemDays}>{lt.days}d</span>
                  </div>
                  {(lt.cf || lt.enc) && (
                    <div style={styles.breakdownItemTags}>
                      {lt.cf && <span style={styles.miniTagCF}>↻ CF {lt.cf}</span>}
                      {lt.enc && <span style={styles.miniTagEnc}>💰 Enc {lt.enc}</span>}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </>
      )}

      <div style={styles.actionsRow}>
        {HasPermission("Holiday", "create") && (
          <button
            style={styles.btnAssign}
            onClick={() => onAssign(module)}
            onMouseEnter={(e) => (e.currentTarget.style.background = "#15803d")}
            onMouseLeave={(e) => (e.currentTarget.style.background = "#16a34a")}
          >
            <PiUserCheck size={16} />
            ASSIGN
          </button>
        )}
        {HasPermission("Holiday", "edit") && (
          <button
            style={styles.btnEdit}
            onClick={() => onEdit(module)}
            onMouseEnter={(e) => (e.currentTarget.style.background = "#5a38e0")}
            onMouseLeave={(e) => (e.currentTarget.style.background = "#6c47ff")}
          >
            <MdOutlineEdit size={16} />
            EDIT
          </button>
        )}
        {HasPermission("Holiday", "delete") && (
          <button
            style={styles.btnDelete}
            onClick={() => onDelete(moduleId)}
            onMouseEnter={(e) => (e.currentTarget.style.background = "#b91c1c")}
            onMouseLeave={(e) => (e.currentTarget.style.background = "#dc2626")}
          >
            <RiDeleteBinLine size={16} />
            DELETE
          </button>
        )}
      </div>
    </div>
  );
};

// ─── Main Component (Parent) ───────────────────────────────────────────────────
const HolidayModule = () => {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user_data")) || {};
  const toast = useGlobalToast();
  const dispatch = useDispatch();

  const store = useSelector((state) => state.moreSettings);
  const commonStore = useSelector((state) => state.common);
  const branchStore = useSelector((state) => state.branch);
  const departmentStore = useSelector((state) => state.department);

  const [moduleList, setModuleList] = useState([]);
  const [show, setShow] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [employeeList, setEmployeeList] = useState([]);
  const [filterEmployeeList, setFilterEmployeeList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [show1, setShow1] = useState(false);
  const [moduleName, setModuleName] = useState("");

  const [isCreating, setIsCreating] = useState(false);
  const [isAssigning, setIsAssigning] = useState(false);

  const [show2, setShow2] = useState(false);
  const [moduleId, setModuleId] = useState("");
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedUsersList, setSelectedUsersList] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [outletName, setOutletName] = useState("");
  const [state, setState] = useState({ branchId: "", departmentId: "" });

  const isSelectAll = selectedUsers.length === employeeList.length && employeeList.length > 0;

  // ── Fetch module list ──
  const getModule = useCallback(() => {
    const path = `${getHolidayMainPath}${user.user_id}`;
    dispatch(getAttendModule(path));
    dispatch(fetchBranchData());
    dispatch(fetchDepartmentData(user.user_id));
  }, []);

  useEffect(() => {
    getModule();
  }, []);

  useEffect(() => {
    if (store.mSetGetAttModSuccess) {
      const rawList = store.mSetGetAttModData ?? [];
      setModuleList(rawList.map(normaliseModule));
      dispatch(initMoreSettState());
    }
    if (departmentStore.depGetSuccess) {
      setDepartmentList(departmentStore.depGetData);
      dispatch(initDepartState());
    }
    if (branchStore.brnGetSuccess) {
      setBranchList(branchStore.brnGetData);
      dispatch(initBranchState());
    }
  }, [store, departmentStore, branchStore, dispatch]);

  // ── Delete ─────────────────────────────────────────────────────────────────
  const handleDelete = (id) => {
    setDeleteId(id);
    setShow(true);
  };
  const handleModalClose = () => setShow(false);
  const handleDeleteSubmit = () => {
    dispatch(
      commonSaveData({
        path: deleteHolidayMainPath,
        data: { userId: user.user_id, holidayId: deleteId },
      })
    );
    handleModalClose();
  };

  // ── Employee list ──────────────────────────────────────────────────────────
  useEffect(() => {
    if (moduleId) {
      const path = getStaffHolidayListPath(user.user_id, moduleId, state.branchId, state.departmentId);
      dispatch(commonGetDataFourth(path));
    }
  }, [state.branchId, state.departmentId, moduleId]);

  useEffect(() => {
    if (commonStore.commonGetFourthSuccess) {
      if (searchQuery !== "") {
        searchEmployees(searchQuery, commonStore.commonGetFourthData);
      } else {
        setEmployeeList(commonStore.commonGetFourthData);
        setFilterEmployeeList(commonStore.commonGetFourthData);
        const init = commonStore.commonGetFourthData.filter((v) => v.holidayAssignedStatus === "1").map((s) => s.staffId);
        const initList = commonStore.commonGetFourthData.filter((v) => v.holidayAssignedStatus === "1");
        setSelectedUsers(init);
        setSelectedUsersList(initList);
      }
      dispatch(initCommonState());
    }
  }, [commonStore.commonGetFourthSuccess]);

  // ── Create module ──────────────────────────────────────────────────────────
  const handleModalClose1 = () => {
    setShow1(false);
    setModuleName("");
    setSearchQuery("");
  };
  const handleShow1 = () => setShow1(true);

  const createHolidayModule = (e) => {
    e.preventDefault();
    if (!moduleName.trim()) {
      toast.warning("Please enter a module name.");
      return;
    }
    setIsCreating(true);
    dispatch(commonSaveData({ path: insertHolidayMainPath, data: { userId: user.user_id, moduleName } }));
  };

  // ── Success / Error ────────────────────────────────────────────────────────
  useEffect(() => {
    if (commonStore.commonSuccess) {
      toast.success(commonStore.commonMessage);

      if (isCreating) {
        const newId = commonStore.commonData?.id ?? commonStore.commonData?.moduleId ?? commonStore.commonData?.holiday_id;
        if (newId) {
          dispatch(initCommonState());
          setIsCreating(false);
          handleModalClose1();
          navigate(`/attendance-settings-holiday/${newId}`);
          return;
        }
      }

      getModule();
      handleModalClose1();
      setSearchQuery("");
      setState({ branchId: "", departmentId: "" });

      if (isAssigning && commonStore.commonData?.id != null) {
        navigate(`/attendance-settings-holiday/${commonStore.commonData.id}`);
      }

      handleModalClose2();
      dispatch(initCommonState());
      setIsCreating(false);
      setTimeout(() => setIsAssigning(false), 300);
    }
    if (commonStore.commonError) {
      toast.error(commonStore.commonMessage);
      handleModalClose1();
      handleModalClose2();
      setIsCreating(false);
      dispatch(initCommonState());
      setSearchQuery("");
      setState({ branchId: "", departmentId: "" });
    }
  }, [commonStore.commonSuccess, commonStore.commonError]);

  // ── Assign ─────────────────────────────────────────────────────────────────
  const handleModalClose2 = () => {
    setShow2(false);
    setEmployeeList([]);
    setSelectedUsers([]);
    setSelectedUsersList([]);
    setSearchQuery("");
    setState({ branchId: "", departmentId: "" });
  };

  const handleAssignClick = (normalised) => {
    const id = normalised.moduleId;
    const name = normalised.moduleName;
    setModuleId(id);
    setOutletName(name);
    setIsAssigning(true);
    setShow2(true);
    const path = getStaffHolidayListPath(user.user_id, id, "", "");
    dispatch(commonGetDataFourth(path));
  };

  const handleInputChange = ({ target: { name, value } }) => {
    setState((prev) => ({ ...prev, [name]: value }));
  };

  const selectUser = (event, userId, u) => {
    const isChecked = event.target.checked;
    setSelectedUsers((prev) => (isChecked ? [...prev, userId] : prev.filter((id) => id !== userId)));
    setSelectedUsersList((prev) => (isChecked ? [...prev, u] : prev.filter((x) => x.staffId !== u.staffId)));
  };

  const SelectAll = (event) => {
    if (event.target.checked) {
      setSelectedUsers(employeeList.map((r) => r.staffId));
      setSelectedUsersList([...employeeList]);
    } else {
      setSelectedUsers([]);
      setSelectedUsersList([]);
    }
  };

  const searchEmployees = (val, dataList) => {
    setSearchQuery(val);
    const list = dataList ?? filterEmployeeList;
    const filtered = list.filter(
      (v) => v.full_name.toLowerCase().includes(val.toLowerCase()) || v.employee_id.toLowerCase().includes(val.toLowerCase())
    );
    setEmployeeList(filtered);
    if (dataList) setFilterEmployeeList(dataList);
  };

  const handleAssignHolidaySubmit = (e) => {
    e.preventDefault();
    dispatch(
      commonSaveData({
        path: assignHolidayEmployeePath,
        data: { userId: user.user_id, staffId: selectedUsers.toString(), moduleId },
      })
    );
  };

  const handleEdit = (module) => navigate(`/attendance-settings-holiday/${module.moduleId}`);

  return (
    <div style={{ position: "fixed", width: "calc(100%)", height: "100%", backgroundColor: "transparent" }}>
      <ToastContainer position="top-right" autoClose={2000} className="toast-custom" />

      {/* Assign Employee Dialog */}
      <AssignEmployee
        isOpen={show2}
        closeOpenDialog={handleModalClose2}
        submitData={handleAssignHolidaySubmit}
        isSelectAll={isSelectAll}
        SelectAll={SelectAll}
        selectedUsersList={selectedUsersList}
        employeeList={employeeList}
        selectedUsers={selectedUsers}
        selectUser={selectUser}
        branchList={branchList}
        departmentList={departmentList}
        state={state}
        handleInputChange={handleInputChange}
        getData={""}
        searchQuery={searchQuery}
        searchEmployees={(val) => searchEmployees(val, null)}
        outletName={outletName}
        dataList={filterEmployeeList}
      />

      {/* ── Create Module Dialog ── */}
      <Dialog
        fullWidth
        maxWidth="sm"
        open={show1}
        onClose={(_, reason) => {
          if (reason !== "backdropClick") handleModalClose1();
        }}
        disableEscapeKeyDown
      >
        <DialogTitle className="dialog-title">
          <div className="dialog-title-icon">
            <span className="close-icon" onClick={handleModalClose1}>
              X
            </span>
            <span className="title">Create New Module</span>
          </div>
          <button className="universal-btn" onClick={createHolidayModule}>
            {isCreating ? "Creating..." : "Add"}
          </button>
        </DialogTitle>
        <DialogContent>
          <Form.Group className="p-2 pt-4">
            <Form.Control
              placeholder="Enter holiday module name"
              value={moduleName}
              name="moduleName"
              onChange={(e) => setModuleName(e.target.value)}
              className="universal-input"
              onKeyDown={(e) => {
                if (e.key === "Enter") createHolidayModule(e);
              }}
            />
          </Form.Group>
        </DialogContent>
      </Dialog>

      {/* Delete Confirm Modal */}
      <Modal show={show} onHide={handleModalClose} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title className="color-white">Delete Module</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to delete this record?</Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            style={{ color: "#fff", height: "30px", lineHeight: "10px", border: "none", width: "100px" }}
            onClick={handleModalClose}
          >
            Cancel
          </Button>
          <Button
            variant="danger"
            style={{ color: "#fff", height: "30px", lineHeight: "10px", border: "none", width: "100px" }}
            onClick={handleDeleteSubmit}
          >
            Delete
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Page Body */}
      <div className="SettingBody">
        <div className="SettingBody-card mt-1" style={{ width: "100%" }}>
          <Widgets
            icon={<WidgetsIcon icon={<Link to="/setting/" className="icon-color"><ArrowBackIcon /></Link>} title="Holiday Module" />}
            button={
              HasPermission("Holiday", "create") && (
                <ButtonCom
                  type="button"
                  class_name="border-radius-8px universal-btn"
                  text="Create Holiday Module"
                  url_or_onclick={handleShow1}
                  icon={<AddIcon />}
                  width=""
                />
              )
            }
            body={
              moduleList.length === 0 ? (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "200px",
                    color: "#6b7280",
                    fontSize: "15px",
                  }}
                >
                  No holiday modules found. Click "Create Holiday Module" to get started.
                </div>
              ) : (
                <div style={styles.grid}>
                  {moduleList.map((module, idx) => (
                    <HolidayCard
                      key={module.moduleId || idx}
                      module={module}
                      onAssign={handleAssignClick}
                      onEdit={handleEdit}
                      onDelete={handleDelete}
                    />
                  ))}
                </div>
              )
            }
          />
        </div>
      </div>
    </div>
  );
};

export default React.memo(HolidayModule);